
/**
 * Comet ajax request types:
 * 1. listen - start listen (long poll)
 * 2. register - add listener
 * 3. unregister - remove listener
 * 4. clear - clear session listeners and events
 * 5. close - delete session
 *
 * config = {
 *  timeout
 *  servletTimeout
 *  onSubscribe
 *  onUnsubscribe
 *  onError
 * }
 */

/*
  EXAMPLE:
  var comet = new invcomet({
    onSubscribe : function(subscribeId, listenerId) {
      comet.addListener({
        onEvent : function(event) {
          ... process event logic
        },
      });
    },
    onUnsubscribe : function() {
      ...
    },
    onError : function(errorId) {
      ...
    }
  });
*/
import { AXIOS } from '../axios/axios.js'

export class Invcomet {
  constructor (config) {
    var me = this

    // config
    me.timeout = config.timeout || 180000
    me.servletTimeout = config.servletTimeout || 120000
    me.onSubscribe = config.onSubscribe
    me.onUnsubscribe = config.onUnsubscribe
    me.onError = config.onError

    // init
    me.closed = false
    me.started = false
    me.listeners = []
    me.listenersIdsToRemove = []
    me.lastRemoveTime = 0
    me.removeListenersProcess = null
    me.subscribeId = null

    me.destroyed = false
    me.startTimer = null
    me.pollTimer = null

    me.servicePath = 'service'
    // start
    me.subscribe()

    // отслеживать изменение активной вкладки
    me.documentVisibilityListener = null
    me.documentVisibilityTimer = null
    me.documentVisibilityCheckInterval = 2000
    me.documentVisibilityListener = e => {
      switch (document.visibilityState) {
        case 'hidden':
          clearTimeout(me.documentVisibilityTimer)
          me.closed = true
          break
        case 'visible':
          // Задержка установки активного состояния, чтобы исключить случай быстрого пролистывания страниц браузера
          me.documentVisibilityTimer = setTimeout(() => {
            me.closed = false
            me.start()
          }, me.documentVisibilityCheckInterval)
          break
      }
    }
    document.addEventListener('visibilitychange', me.documentVisibilityListener)
  }

  /**
   * Start long poll.
   */
  start () {
    var me = this
    if (me.started || me.closed) {
      return
    }
    me.started = true

    try {
      me.request({
        url: me.getServiceURL({
          service: 'comet',
          request: 'listen',
          args: {
            id: me.subscribeId,
            timeout: me.servletTimeout
          }
        }),
        timeout: me.timeout,
        method: 'GET',
        scope: me,
        success: function (resp) {
          if (resp.status === 200) {
            // console.log('comet> response: status=' + resp.status + ' ' + resp.statusText + ', response: ' + resp.data)

            var result = resp.data
            if (result.status == 'resubscribe') {
              me.subscribeId = result.subscribeid
              me.started = false
              me.start()
              return
            } else if (result.status != 'success') {
              if (me.onError) {
                me.onError('listen_error')
              }
              return
            }

            var events = result.events
            if (events) {
              me.processEvent(events)
            }

            me.started = false
            me.start()
            return
          }

          me.startTimer = setTimeout(function () {
            me.started = false
            me.start()
          }, 250)
        },
        failure: function (resp, opts) {
          if (resp.timeout === true || resp.status == 504) {
            // console.log('comet> restart on timeout')
            me.startTimer = setTimeout(function () {
              me.started = false
              me.start()
            }, 250)
          } else {
            // console.log('comet> failure start')
            // console.log(resp)
          }
        }
      })
    } catch (error) {
      // console.log('comet> start error: ' + error)
    }

    if (!me.removeListenersProcess) {
      me.removeListenersProcess = {
        started: true,
        stopped: false,
        shortTimeout: 100,
        longTimeout: 1000,
        timeout: 100,
        pollCount: 0,
        removedCount: 0,
        poll: function () {
          var process = this
          if (me.closed || !me.started || !process.started) {
            process.started = false
            process.stopped = true
            return
          }
          process.pollCount++
          if (me.listenersIdsToRemove.length > 0 && new Date().getTime() - me.lastRemoveTime > 1000) {
            var listenersIdsToRemove = me.listenersIdsToRemove.slice(0)
            me.removeListeners(listenersIdsToRemove, function (success, removedCount) {
              process.removedCount += removedCount
              process.timeout = success ? process.shortTimeout : process.longTimeout
              process.poll()
            })
          } else {
            me.pollTimer = setTimeout(function () {
              process.timeout = process.shortTimeout
              process.poll()
            }, process.timeout)
          }
        }
      }
      me.removeListenersProcess.poll()
    }
  }

  /**
   * Process events
   *
   * @param events
   */
  processEvent (events) {
    if (events.length == 0) {
      return
    }

    // console.log('comet> event received: count=' + events.length)
    for (var ei = 0; ei < events.length && !this.closed; ei++) {
      var event = events[ei]
      for (var i = 0; i < this.listeners.length && !this.closed; i++) {
        var listener = this.listeners[i]
        var process = true
        if (listener.isListen && !listener.isListen(event)) {
          process = false
        }

        if (process && listener.onEvent != undefined) {
          try {
            if (listener.scope) {
              listener.onEvent.call(listener.scope, event)
            } else {
              listener.onEvent(event)
            }
          } catch (error) {
            // console.log('comet process event error: ' + error)
          }
        }
      }
    }
  }

  //  Listener description:
  //  var listener = {
  //    /**
  //     * Available types:
  //     * TODO
  //     */
  //    type : undefined,
  //
  //    /**
  //     * Id of the listener.
  //     * Event contains property 'listeners' type of Array to determine listeners to invoke onEvent.
  //     * If empty then listener filtrate event itself.
  //     */
  //    listenerId : undefined,
  //
  //    /**
  //     * Scope for onEvent and callback functions
  //     */
  //     scope : undefined,
  //
  //    /**
  //     * Gui component associated with this listener.
  //     * During destroying of the component, the listener will be deleted locally and remotely.
  //     */
  //    component : undefined,
  //
  //    /**
  //     * callbacks
  //     */
  //    onRegisterSuccess : undefined,
  //    onRegisterFailure : undefined,
  //    onUnregisterSuccess : undefined,
  //    onUnregisterFailure : undefined,
  //
  //    /**
  //     * @param event
  //     */
  //    onEvent : function(event) {
  //    },
  //
  //    /**
  //     * Common logic for events filtration
  //     * @param event
  //     * @returns {Boolean}
  //     */
  //    isListen : function(event) {
  //      if (this.listenerId && event.listeners && event.listeners.indexOf(this.listenerId) == -1) {
  //      return false;
  //    }
  //
  //      return this.type && this.type == event.type;
  //    }
  //  }

  /*
    EXAMPLE:
    var listenerId = gen_uuid_itself();
    var userLogsListener = {
      type : 'user.log',
      listenerId : listenerId,
      onEvent : function(event) {
        yourLogic();
      }
    };
    comet.addListener(userLogsListener);
  */

  /**
   * @param listener
   */
  addListener (listener) {
    var me = this
    if (!me.closed && me.listeners.indexOf(listener) == -1) {
      me.listeners.push(listener)
    }
  }

  /**
   * Remove listeners.
   * @param listenerIds - listener id or array of listeners ids
   */
  removeListeners (listenerIds, callback) {
    var me = this
    try {
      if (typeof listenerIds !== 'object') {
        return
      }
      if (listenerIds.constructor !== Array) {
        listenerIds = [listenerIds]
      }

      // remove locally
      for (var i = me.listeners.length - 1; i >= 0; i--) {
        var listener = me.listeners[i]
        if (listenerIds.indexOf(listener.listenerId) != -1) {
          var index = me.listeners.indexOf(listener)
          if (index != -1) {
            me.listeners.splice(index, 1)
            // console.log('comet> remove listener: ' + listener)
          }
        }
      }

      // remove remotely
      me.request({
        url: me.getServiceURL({
          service: 'comet',
          request: 'removelistener'
        }),
        method: 'POST',
        timeout: 1000,
        params: {
          id: me.subscribeId,
          lid: listenerIds.join(',')
        },
        success: function (resp) {
          if (resp.status === 200) {
            var removedCount = 0
            listenerIds.forEach(function (listenerId) {
              var index = me.listenersIdsToRemove.indexOf(listenerId)
              if (index != -1) {
                me.listenersIdsToRemove.splice(index, 1)
                removedCount++
              }
            })
            if (removedCount > 0) {
              // console.log('comet> remote listener removed successfully: ' + listenerIds + ', count=' + removedCount)
            }
            if (callback) {
              // eslint-disable-next-line standard/no-callback-literal
              callback(true, removedCount)
            }
          } else {
            // console.log('comet> remove remote listener failed: ' + listenerIds)
            if (callback) {
              // eslint-disable-next-line standard/no-callback-literal
              callback(false, 0)
            }
          }
        },
        failure: function (resp, opts) {
          // console.log('comet> remove remote listener failed: ' + listenerIds)
          if (callback) {
            // eslint-disable-next-line standard/no-callback-literal
            callback(false, 0)
          }
        }
      })
    } catch (error) {
      // console.log('comet> remove remote listener failed: ' + listenerIds + ' (' + error + ')')
      if (callback) {
        // eslint-disable-next-line standard/no-callback-literal
        callback(false, 0)
      }
    }
  }

  clear () {
    var me = this
    var clearedListeners = []
    for (var i = 0; i < me.listeners.length; i++) {
      var listener = me.listeners[i]
      if (listener.permanent) {
        clearedListeners.push(listener)
      }
    }
    me.listeners = clearedListeners
  }

  /**
   *
   */
  subscribe (callback) {
    var me = this
    if (me.started) {
      // eslint-disable-next-line standard/no-callback-literal
      callback(false)
      return
    }

    // console.log('comet> subscribe...')
    try {
      me.request({
        url: me.getServiceURL({
          service: 'delta/userevents',
          request: 'subscribe'
        }),
        timeout: 60000,
        method: 'POST',
        scope: me,
        success: function (resp) {
          if (resp.status === 200) {
            me.subscribeId = resp.data.subscribeId
            me.subscribeListenerId = resp.data.listenerId
            // console.log('comet> subscribed successfully')
            if (callback) {
              // eslint-disable-next-line standard/no-callback-literal
              callback(true)
            }
            if (me.onSubscribe) {
              me.onSubscribe(me.subscribeId, resp.data.listenerId)
            }
            me.start()
          }
        },
        failure: function (resp, opts) {
          // console.log('comet> subscribe failed')
          if (callback) {
            // eslint-disable-next-line standard/no-callback-literal
            callback(false)
          }
        }
      })
    } catch (error) {
      // console.log(error)
      if (callback) {
        // eslint-disable-next-line standard/no-callback-literal
        callback(false)
      }
    }
  }

  /**
   *
   */
  unsubscribe (callback) {
    var me = this
    if (me.closed) {
      // eslint-disable-next-line standard/no-callback-literal
      callback(false)
      return
    }

    // console.log('comet> unsubscribe...')
    try {
      const bodyFormData = new FormData()
      bodyFormData.set('id', me.subscribeId)
      me.request({
        url: me.getServiceURL({
          service: 'delta/userevents',
          request: 'unsubscribe'
        }),
        method: 'POST',
        timeout: 1000,
        params: bodyFormData,
        success: function (resp) {
          if (resp.status === 200) {
            me.closed = true
            // console.log('comet> unsubscribed successfully')
            if (callback) {
              // eslint-disable-next-line standard/no-callback-literal
              callback(true)
            }
            if (me.onUnsubscribe) {
              me.onUnsubscribe()
            }
          }
        },
        failure: function (resp, opts) {
          // console.log('comet> unsubscribe failed')
          if (callback) {
            // eslint-disable-next-line standard/no-callback-literal
            callback(false)
          }
        }
      })
    } catch (error) {
      // eslint-disable-next-line standard/no-callback-literal
      callback(false)
    }
  }

  getServiceURL (config) {
    var module = config.module
    if (!module) {
      module = this.servicePath
    }
    var service = config.service
    var request = config.request
    var args = config.args

    var url = module
    if (service) {
      url += '/' + service
    }
    if (request) {
      url += '/' + request
    }
    if (args) {
      var i = 0
      for (var key in args) {
        if (i == 0) {
          url += '?'
        } else {
          url += '&'
        }
        var value = args[key]
        if (typeof value === 'object') {
          value = JSON.stringify(value)
        } else if (value instanceof Date) {
          value = value.toISOString()
        }
        url += key + '=' + encodeURIComponent(value)
        i++
      }
    }
    return url
  }

  /**
   * config = {
   *  url,
   *  method (GET, POST),
   *  timeout,
   *  params,
   *  success,
   *  failure
   * }
   */
  request (config) {
    AXIOS({
      url: config.url,
      method: config.method || 'GET',
      data: config.params,
      timeout: config.timeout
    })
      .then((response) => {
        if (response.status == 200) {
          config.success(response)
        } else {
          config.failure(response)
        }
      })
      .catch((error) => {
        config.failure(error.response)
      })
  }

  destroy () {
    this.closed = true
    this.listeners.splice(0, this.listeners.length)

    document.removeEventListener('visibilitychange', this.documentVisibilityListener)

    if (this.documentVisibilityTimer) {
      clearTimeout(this.documentVisibilityTimer)
      this.documentVisibilityTimer = null
    }
    if (this.startTimer) {
      clearTimeout(this.startTimer)
      this.startTimer = null
    }
    if (this.pollTimer) {
      clearTimeout(this.pollTimer)
      this.pollTimer = null
    }
  }
}
